import { Component, EventEmitter, forwardRef, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, Validator, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-pump-system-type',
    templateUrl: './pump-system-type.component.html',
    styleUrls: ['./pump-system-type.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PumpSystemTypeComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PumpSystemTypeComponent),
            multi: true
        }
    ],
    standalone: false
})
export class PumpSystemTypeComponent implements OnDestroy, ControlValueAccessor, Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  types = ['Default', 'AHR', 'AHRE', 'AHRP', 'BOOST', 'C', 'CS', 'Custom', 'GRUNDFOS', 'HR', 'HRE', 'Lowara', 'SHRE'];

  typeStore = '';
  private subscriptions: Subscription[] = [];

  @Output() selectionChange = new EventEmitter<MatSelectChange>();

  selectListControl = new UntypedFormControl('');

  typeChangeAction(event) {
    this.typeStore = event.value;
    this.selectionChange.emit(event);
  }

  // model --> view
  writeValue(value: string): void {
    if (value) {
      this.typeStore = value;
      this.selectListControl.setValue(value, { emitEvent: false });
    } else {
      this.selectListControl.reset('');
    }
  }

  // view --> model
  registerOnChange(fn: (value: string) => void) {
    const onChangeSubscription = this.selectListControl.valueChanges.subscribe(fn);
    this.subscriptions.push(onChangeSubscription);
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  onTouched: () => void = () => { };

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
